import { getCountries } from "libphonenumber-js/max";
import { countries } from "@/components/countries";

const PHONE_COUNTRIES = new Set(getCountries());

function normalizedName(value) {
  return String(value ?? "")
    .trim()
    .toLocaleLowerCase()
    .normalize("NFKD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[.(),_-]+/g, " ")
    .replace(/\s+/g, " ");
}

const ALIASES = {
  ru: ["рф", "российская федерация", "russian federation"],
  gb: ["uk", "u k", "great britain", "england", "соединенное королевство", "англия"],
  us: ["usa", "u s a", "united states of america", "сша"],
  ae: ["uae", "оаэ"],
  cz: ["czech republic"],
  nl: ["holland", "голландия"],
  kg: ["kirgizia", "киргизия"],
  kr: ["south korea", "korea", "южная корея", "корея"],
  mk: ["macedonia", "македония"],
  mm: ["burma", "бирма"],
};

const COUNTRY_BY_NAME = new Map();

countries.forEach((country) => {
  const code = country.code === "AB" ? "RU" : country.code;
  if (!PHONE_COUNTRIES.has(code)) return;
  [country.name, country.russian, country.native].forEach((name) => {
    const key = normalizedName(name);
    if (key) COUNTRY_BY_NAME.set(key, code);
  });
});

Object.entries(ALIASES).forEach(([code, names]) => {
  names.forEach((name) => COUNTRY_BY_NAME.set(normalizedName(name), code.toUpperCase()));
});

export function resolvePhoneCountry(value) {
  const text = String(value ?? "").trim();
  if (!text) return "";

  const code = text.toUpperCase();
  if (code === "AB") return "RU";
  if (PHONE_COUNTRIES.has(code)) return code;

  return COUNTRY_BY_NAME.get(normalizedName(text)) || "";
}

export function defaultPhoneCountry({ client, company } = {}) {
  return (
    resolvePhoneCountry(client?.country) ||
    resolvePhoneCountry(company?.country_code) ||
    resolvePhoneCountry(company?.country) ||
    ""
  );
}
